function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#f0f0f0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6h14.16A10 10 0 005 1.35z",
  fill: "#00732f"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.16 14H5v4.65A10 10 0 0019.16 14z",
  fill: "#212121"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 18.65V1.35a10 10 0 000 17.3z",
  fill: "red"
});

function SvgAe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojMDA3MzJmO30uY2xzLTN7ZmlsbDojMjEyMTIxO30uY2xzLTR7ZmlsbDpyZWQ7fTwvc3R5bGU+PC9kZWZzPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik01LDZIMTkuMTZBMTAsMTAsMCwwLDAsNSwxLjM1WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTE5LjE2LDE0SDV2NC42NUExMCwxMCwwLDAsMCwxOS4xNiwxNFoiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik01LDE4LjY1VjEuMzVhMTAsMTAsMCwwLDAsMCwxNy4zWiIvPjwvc3ZnPg==";
export { SvgAe as ReactComponent };